/**
 *
 * @returns Bearer ${accessKey}
 */
export function getAccessKey() {
  return localStorage.getItem('accessToken');
}
